<template>
  <v-card flat class="mt-6">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title class="subtitle-1">
              <v-icon left color="primary">mdi-note-text</v-icon>
              Nota
            </v-card-title>
            <v-card-text>
              <v-textarea
                :value="internalNote"
                @input="handleNoteChange"
                outlined
                label="Nota"
                :rows="totales.total_withholding > 0?'4':'3'"
              ></v-textarea>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title class="subtitle-1">
              <v-icon left color="primary">mdi-calculator</v-icon>
              Resumen
            </v-card-title>
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="text-right">Subtotal</td>
                      <td class="text-right">{{ totales.tot_sub }}</td>
                    </tr>
                    <tr>
                      <td class="text-right">Descuento</td>
                      <td class="text-right">{{ currencyFormat(totales.discount) }}</td>
                    </tr>
                    <tr>
                      <td class="text-right">ITBIS</td>
                      <td class="text-right">
                        {{ currencyFormat(totales.total_itbis) }}
                      </td>
                    </tr>                   
                    <tr class="primary--text font-weight-bold">
                      <td class="text-right">Total</td>
                      <td class="text-right">
                        {{ currencyFormat(totales.tot_amount) }}
                        {{ currencies.find((c) => c.id === seleted_currencies)?.code }}
                      </td>
                    </tr>
                     <tr v-if="totales.total_withholding > 0">
                      <td class="text-right">Retenido</td>
                      <td class="text-right">
                        {{ currencyFormat(totales.total_withholding) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title class="subtitle-2">
              <v-icon left color="green">mdi-cash-plus</v-icon>
              Pagos
            </v-card-title>
            <v-card-text>
              <v-list dense>
                <v-list-item v-for="(item, i) in selectedPayments" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field
                        v-model="item.amount"
                        type="number"
                        dense
                        outlined
                        hide-details
                        class="mt-1"
                      ></v-text-field>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon small @click="$emit('deletePayment', item)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-btn
                v-if="!disableInput && type !== 6"
                color="primary"
                outlined
                block
                class="mt-2"
                :disabled="type === 3 || type === 4"
                @click="$emit('showDialogPayments')"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar pago
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="type === 1" cols="12" md="6">
          <v-card outlined>
            <v-card-title class="subtitle-2 mb-0 pb-0">
              <v-icon left color="orange">mdi-cash-remove</v-icon>
              Retenciones al total de la factura
            </v-card-title>
            <v-card-text>
              <v-list dense>
                <v-list-item v-for="(item, i) in selected_withholdings" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon small @click="$emit('delete_withholdings', item)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-divider
                v-if="selected_withholdings && selected_withholdings.length > 0"
                class="my-2"
              ></v-divider>
              <!-- <v-row
                v-if="selected_withholdings && selected_withholdings.length > 0"
                class="mx-0"
              >
                <v-col cols="8" class="text-right font-weight-bold">
                  Total Retención:
                </v-col>
                <v-col cols="4" class="text-right font-weight-bold">
                  {{ currencyFormat(totalRetenciones) }}
                </v-col>
              </v-row> -->
              <v-btn
                color="primary"
                outlined
                block
                class="mt-2"
                :disabled="type === 3 || type === 4"
                @click="$emit('dialogWithholdings')"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar retención
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card-actions class="mt-4">
        <!-- <v-btn
          color="primary"
          outlined
          :disabled="type === 3 || type === 4 || disableInput"
          @click="$emit('showItems')"
        >
          <v-icon left>mdi-plus</v-icon>
          Agregar item
        </v-btn> -->
        <v-btn
          v-if="type == 2"
          color="primary"
          outlined
          :disabled="type === 3 || type === 4 || disableInput"
          @click="$emit('showVouchers')"
        >
          <v-icon left>mdi-ticket-percent</v-icon>
          Agregar Vouchers
        </v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn color="primary" @click="$emit('save')">
          <v-icon left>mdi-content-save</v-icon>
          Guardar
        </v-btn> -->
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      internalNote: this.note,
    };
  },
  created() {
    //this.getData();
  },

  props: {
    disableInput: {
      type: Boolean,
    },
    tipComprobante: {
      type: Object,
    },
    note: {
      type: String,
    },
    type: {
      type: Number,
    },
    selected_withholdings: {
      type: Array,
    },
    selectedVouchers: {
      type: Array,
    },
    selectedPayments: {
      type: Array,
    },
    currencies: {
      type: Array,
    },

    totales: {
      type: Object,
    },
    totNote: {
      type: Number,
    },
    discountInventory: {
      type: Boolean,
    },
    seleted_currencies: {
      type: Number,
    },
  },
  computed: {
    totalRetenciones() {
      if (!this.selected_withholdings || this.selected_withholdings.length === 0) {
        return 0;
      }
      return this.selected_withholdings.reduce((total, retencion) => {
        const porcentaje = parseFloat(retencion.percent) || 0;
        const subtotal = parseFloat(this.totales.tot_sub) || 0;
        return total + subtotal * porcentaje;
      }, 0);
    },
  },
  watch: {
    note: {
      handler(newVal) {
        this.internalNote = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    handleNoteChange(value) {
      this.internalNote = value;
      this.$emit("nota", value); // Emitting the event you're already listening for
    },
    delete_withholdings(item) {
      this.$emit("delete_withholdings", item);
    },
  },
};
</script>
